import { type BlackboardInstance } from "./blackboardModels";

export function getInstanceLifetimeTokenTotal(
  instance: BlackboardInstance,
): number {
  return instance.tokenUsage.inputTokens + instance.tokenUsage.outputTokens;
}

export function getInstanceActorWakeCacheHitPct(
  instance: BlackboardInstance,
): number | null {
  return instance.actorWakeCacheStats?.cacheHitPct
    ? Math.round(instance.actorWakeCacheStats.cacheHitPct)
    : null;
}

export function getInstanceRestartWarningCount(
  instance: BlackboardInstance,
): number | null {
  return instance.runCount > 1 ? instance.runCount - 1 : null;
}
